import { ABOUT } from "../data/resumeData";

const formatAbout = (list) => {
    if (!list.length) return '';
  
    const formatted = [...list];
    formatted[0] = formatted[0].charAt(0).toUpperCase() + formatted[0].slice(1); // Capitalize first word
  
    if (formatted.length === 1) return formatted[0];
  
    const last = formatted.pop();
    return `${formatted.join(', ')}, and ${last}.`;
  };

function About() {
    return (
      <section className="fade-in">
        <h2>Summary</h2>
        
            <p className="indent">{formatAbout(ABOUT)}</p>
        
      </section>
    );
  }
  
  export default About;